import { openDialog, cleanDialogStack } from '@patrianna/dialog-manager'
import { useMediaQuery } from '@patrianna/shared-hooks'
import { getTranslationFromJson } from '@patrianna/shared-utils/prismic'

import content from 'prismic-translates/loginpage.json'
import FacebookButton from 'src/containers/FacebookButton'
import GoogleAuthButton from 'src/containers/GoogleAuthButton'
import usePasswordChangedNotification from 'src/hooks/usePasswordChangedNotification'

import AuthDialogLayout from '../AuthDialogLayout'

import LoginDialogContent from './LoginDialogContent'
import ManualLogin from './ManualLogin'

const t = getTranslationFromJson([content])

type Props = {
  loginWays?: 'social_only' | 'manual_only' | 'all'
}

export default function Login(props: Props) {
  const matches = useMediaQuery('xs')

  usePasswordChangedNotification()

  const onForgotPassword = () => {
    if (!matches) {
      cleanDialogStack()
    }
    openDialog({ dialogName: 'RESET_PASSWORD_DIALOG' })
  }

  if (props.loginWays === 'manual_only') {
    return (
      <AuthDialogLayout dataTest='manual-login-dialog'>
        <ManualLogin onForgotPassword={onForgotPassword} />
      </AuthDialogLayout>
    )
  }
  if (props.loginWays === 'social_only') {
    return (
      <AuthDialogLayout dataTest='social-login-dialog'>
        <FacebookButton authType='LOGIN' text={t('facebookButtonLabel')} />
        <GoogleAuthButton authType='LOGIN' title={t('googleButtonLabel')} />
      </AuthDialogLayout>
    )
  }

  return (
    <AuthDialogLayout dataTest='login-dialog'>
      <LoginDialogContent />
    </AuthDialogLayout>
  )
}
